export default __webpack_public_path__ + "static/media/DEXE-BUSD.051c2834.svg";